import React, { useState } from 'react';
import Lottie from 'lottie-react';
import WelcomeScreenanimation from '../Assets/animations/welcomscreenrotation.json';
import vikritinext from '../Assets/images/vikritinext.png';
import { useNavigate, useLocation } from 'react-router-dom';
import individualuser from '../Assets/images/Individual User 1.png';
import corpuser from '../Assets/images/corporate user 1.png';
import infoIconImg from '../Assets/images/Group 16493.png'
import { ChevronLeft, ArrowBack, InfoOutlined, Close } from '@mui/icons-material';
import { IconButton, Dialog, DialogTitle, DialogContent } from '@mui/material';

function OnBoardUser() {

    const navigate = useNavigate();
    const location = useLocation();

    const [openCorpDialog, setOpenCorpDialog] = useState(false);

    const [openIndDialog, setOpenIndDialog] = useState(false);

    return (
        <div className="Onboarding-Screen">
            <div className="flex flex-col items-center w-auto" style={{ width: '100%' }}>
                <nav className='flex flex-row w-full p-2'>
                    <IconButton onClick={() => navigate(-1)}>
                        <ArrowBack />
                    </IconButton>
                </nav>

                <div className='flex flex-col items-center'>

                    <div className="Welcome-section-animation">
                        <Lottie animationData={WelcomeScreenanimation} />
                    </div>

                    <p className='text-center Welcome-section-animation-txt mt-5'>Choose your user profile</p>
                </div>

                <div className="container mt-10">

                    <div className='onboardUserBox flex items-center relative'
                        onClick={() => navigate('/CorpWelcomeScreen', { state: { from: location?.state?.from } })}
                        style={{
                            background: "linear-gradient(90deg, #FDFDFD 50%, #FFE1C6 50%)",
                            border: "3px solid",
                            borderImage: "linear-gradient(90deg, transparent 40%, #DA6E0B 60%) 1",
                        }}
                    >

                        <IconButton
                            onClick={(e) => {
                                e.stopPropagation();
                                setOpenCorpDialog(true);
                            }}
                            style={{
                                position: 'absolute',
                                top: '10px',
                                right: '10px',
                                color: '#DA6E0B',
                            }}
                        >
                            <InfoOutlined />
                        </IconButton>

                        <p className="ml-4">Corporate User</p>
                        <img src={corpuser} alt="Corporate User" className="ml-auto mr-4" />
                    </div>

                    <div className='onboardUserBox flex items-center relative'
                        onClick={() => navigate('/App-features', { state: { from: location?.state?.from } })}
                        style={{
                            background: "linear-gradient(90deg, #FDFDFD 50%, #FFE1C6 50%)",
                            border: "3px solid",
                            borderImage: "linear-gradient(90deg, transparent 40%, #DA6E0B 60%) 1",
                        }}>

                        <IconButton

                            onClick={(e) => {
                                e.stopPropagation();
                                setOpenIndDialog(true);
                            }}

                            style={{
                                position: 'absolute',
                                top: '10px',
                                right: '10px',
                                color: '#DA6E0B',
                            }}
                        >
                            <InfoOutlined />
                        </IconButton>

                        <p className="ml-4">Individual User</p>
                        <img src={individualuser} alt="Individual User" className="ml-auto mr-4" />
                    </div>
                </div>

                <Dialog open={openCorpDialog} onClose={() => setOpenCorpDialog(false)}>
                    <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <p style={{
                            fontFamily: "'Poppins', sans-serif",
                            fontWeight: 500,
                        }}>
                            Corporate User
                        </p>
                        <IconButton onClick={() => setOpenCorpDialog(false)} size="small" sx={{ color: 'grey.600' }}>
                            <Close />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent>

                        <div className='flex flex-col items-center gap-5'>
                            <img src={infoIconImg} className='w-20' alt="Info" />
                            <p className='text-[#3B362A] text-xl text-center' style={{
                                fontFamily: "'Poppins', sans-serif",
                                fontWeight: 400,
                            }}>
                                This option is for users onboarded by their organization to promote employee well-being
                            </p>
                        </div>

                    </DialogContent>
                </Dialog>


                <Dialog open={openIndDialog} onClose={() => setOpenIndDialog(false)}>
                    <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

                        <p style={{
                            fontFamily: "'Poppins', sans-serif",
                            fontWeight: 500,
                        }}>
                            Individual User
                        </p>
                        <IconButton onClick={() => setOpenIndDialog(false)} size="small" sx={{ color: 'grey.600' }}>
                            <Close />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent>

                        <div className='flex flex-col items-center gap-5'>
                            <img src={infoIconImg} className='w-20' alt="Info" />
                            <p className='text-[#3B362A] text-xl text-center' style={{
                                fontFamily: "'Poppins', sans-serif",
                                fontWeight: 400,
                            }}
                            >
                                This option is for users looking to improve their personal wellness
                            </p>
                        </div>

                    </DialogContent>
                </Dialog>
            </div>
        </div>
    );
}

export default OnBoardUser;
